export default __webpack_public_path__ + "static/media/87.24bba3ee.jpg";